// src/auth/AuthContext.js
import React, { useContext, useEffect, useState, createContext } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔥 טעינת המשתמש + האזנה למסמך ב-Firestore בזמן אמת
  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);

      if (user) {
        const ref = doc(db, "users", user.uid);

        const unsubDoc = onSnapshot(ref, (snap) => {
          if (snap.exists()) {
            setUserData(snap.data());
          } else {
            setUserData(null);
          }
          setLoading(false);
        });

        return unsubDoc;
      } else {
        setUserData(null);
        setLoading(false);
      }
    });

    return unsubAuth;
  }, []);

  const logout = () => {
    setCurrentUser(null);
    setUserData(null);
    return signOut(auth);
  };

  return (
    <AuthContext.Provider
      value={{ currentUser, userData, logout, setUserData }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
}
